import { useDragDropContext } from '../drag-drop-context/internal-context';
export function useKeyboardContext() {
  var _useDragDropContext = useDragDropContext(),
    startKeyboardDrag = _useDragDropContext.startKeyboardDrag;
  return {
    startKeyboardDrag: startKeyboardDrag
  };
}